<template>
  <div class="grid-x bg-white">
    <div class="cell small-12 medium-6 medium-offset-3">
      <div class="yellow-box">
        <p class="text-bold">
          Reporting of side effects
        </p>
        <p>
          If you get any side effects, talk to your doctor. This includes any possible side effects
          not listed in the patient leaflet. You can also report side effects directly via the
          national reporting system:
        </p>
        <p class="text-bold" v-if="country === 1">
          United Kingdom
        </p>
        <p v-if="country === 1">
          Please report suspected adverse drug reactions (ADRs) to the MHRA through the Yellow Card
          Scheme, via the Yellow Card website www.mhra.gov.uk/yellowcard, the free Yellow Card app
          available in Apple App Store or Google Play Store. Alternatively, you can call
          0800 731 6789 for free, Monday to Friday between 9am and 5pm.
        </p>
        <p class="text-bold" v-if="country === 2">
          Ireland
        </p>
        <p v-if="country === 2">
          HPRA Pharmacovigilance
          Website: www.hpra.ie
        </p>
        <p>
          By reporting side effects you can help provide more information on the safety of this
          medicine.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'YellowBox',
  props: [
    'country',
  ],
};
</script>

<style lang="scss">
.yellow-box {
  background-color: #ffb300;
  border-radius: 10px;
  padding: 10px;
  margin: 20px;
}
</style>
